export enum GelatoSubscriptionType {
  GELATO_FREE = 'gelato-free',
  GELATO_PLUS = 'gelato-plus',
  GELATO_GOLD = 'gelato-gold',
  GELATO_PLATINUM = 'gelato-platinum',
}
